import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

const LoadingSpinner = ({ 
  size = 60, 
  thickness = 4, 
  color = '#3498B7',
  fullHeight = true,
  backgroundColor = '#f5f5f5'
}) => {
  const containerStyles = fullHeight ? {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    backgroundColor: backgroundColor
  } : {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '2rem'
  };

  return (
    <Box sx={containerStyles}>
      <CircularProgress
        size={size}
        thickness={thickness}
        sx={{ color: color }}
      />
    </Box>
  );
};

export default LoadingSpinner;
